import React, { useContext, useState, useEffect } from "react";
import Avatar from "../../VibehutUI/Avatar";
import Button from "../../VibehutUI/Button";
import moment from "moment";
import { StoreContext } from "../../Context/StoreContext";
import Loader from "../Loader";
import { updateHomeRsvp, getHomepageEvents } from "../../actions/eventActions";
import {
  showAddressBookModal,
  showLoginModal,
} from "../../actions/uiModalActions";
import { useHistory } from "react-router-dom";
import { getUserData } from "../../services/userService";
import UserListModal from "../UserListModal";
import LiveIcon from "../Icons/LiveIcon";
import ProfileModal from "../ProfileModal";
import { frontEndURL, videoAppUrl } from "../../utils/axios";
import CopyButton from "../CopyButton";
import HomeEventSkeleton from "../Skeletons/HomeEventSkeleton";
import { getNotificationSettings } from "../../services/notificationService";
import useIsPWA from "../../hooks/usePWA";
import ConfirmationModal from "../ConfirmationModal";

function UserAvatar({ rsvp, index, avatarSize }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div key={index} className="">
      <ProfileModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        user={getUserData(rsvp.user)}
      />

      <div className="cursor-pointer" onClick={() => setIsOpen(true)}>
        <Avatar
          src={getUserData(rsvp.user).profile_picture}
          username={getUserData(rsvp.user).username}
          size={avatarSize}
        />
      </div>
    </div>
  );
}

function PopularEventCard() {
  const { state, dispatch } = useContext(StoreContext);
  const {
    auth: { user },
    event: { eventId, homePageEvent, isFetching },
  } = state;
  const history = useHistory();

  var startTime = moment(homePageEvent?.startDate);
  var endTime = moment(homePageEvent?.endDate);
  var today = moment().endOf("day");
  var tomorrow = moment().add(1, "days").endOf("day");
  const currntTime = moment().format();

  const [isOpenUserList, setIsOpenUserList] = useState(false);
  const [avatarSize, setAvatarSize] = useState("54px");
  const [screenWidth, setScreenWidth] = React.useState(window.innerWidth);
  const [openConfirmationModal, setOpenConfirmationModal] = useState(false);

  const isPWA = useIsPWA();
  const isLive =
    moment(homePageEvent?.startDate).format() < currntTime &&
    moment(homePageEvent?.endDate).format() > currntTime;

  useEffect(() => {
    window.addEventListener("resize", () => {
      setScreenWidth(window.innerWidth);
    });

    if (screenWidth < 1380 && screenWidth > 1279) {
      setAvatarSize("50px");
    } else if (screenWidth < 850 && screenWidth > 760) {
      setAvatarSize("50px");
    } else {
      setAvatarSize("54px");
    }
  }, [screenWidth]);

  useEffect(() => {
    if (homePageEvent === null) {
      getHomepageEvents(user?.token, dispatch);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const goToRoom = () => {
    const roomId =
      homePageEvent.room instanceof Array
        ? homePageEvent.room[0]?._id
        : homePageEvent.room?._id;
    if (roomId) {
      return history.push(`/${roomId}`);
    }
  };

  const goToGeneralLobby = () => {
    const roomId =
      homePageEvent.room instanceof Array
        ? homePageEvent.room[0]?._id
        : homePageEvent.room?._id;
    if (!isPWA) {
      window.open(`${videoAppUrl}/call?roomKey=${roomId}`);
    } else {
      window.location.href = `${videoAppUrl}/call?roomKey=${roomId}`;
    }
  };

  const _renderEventTime = () => {
    let timeRangeString = "";
    const isAMsame = startTime.format("a") === endTime.format("a");
    if (startTime.format("mm") === "00") {
      timeRangeString =
        timeRangeString + startTime.format(`h${isAMsame ? "" : " A"}`);
    } else {
      timeRangeString =
        timeRangeString + startTime.format(`h:mm ${isAMsame ? "" : " A"}`);
    }
    timeRangeString = timeRangeString + `-${" "}`;
    if (endTime.format("mm") === "00") {
      timeRangeString = timeRangeString + endTime.format("h A");
    } else {
      timeRangeString = timeRangeString + endTime.format("h:mm A");
    }
    const zone = moment.tz.guess();
    const abbr = moment.tz(zone).format("z");

    if (endTime < new Date()) {
      return `${startTime.format("MMM D,")} ${timeRangeString} ${abbr}`;
    }

    return `${
      isLive
        ? "LIVE"
        : startTime < today
          ? "TODAY"
          : startTime < tomorrow
            ? "Tomorrow"
            : startTime.format("MMM D,")
    } ${timeRangeString} ${abbr}`;
  };

  const isRoomModerator = (room) => {
    if (
      user &&
      (room.owner?._id?.toString() === user._id.toString() ||
        room.owner === user._id.toString())
    ) {
      return true;
    }

    if (room.moderators) {
      for (let i = 0; i < room.moderators.length; i++) {
        if (room.moderators[i].toString() === user._id.toString()) return true;
      }
    }
    return false;
  };

  const rsvpBasedOnUserPrompt = (isGroupRSVP = false) => {
    const status = homePageEvent.user_rsvp?.find(
      (rsvp) => rsvp.user._id === user?._id && rsvp.status === "confirmed",
    )
      ? "removed"
      : "confirmed";
    updateHomeRsvp(
      {
        event: homePageEvent._id,
        status: status,
        ...(isGroupRSVP && {
          isGroupRSVP: true,
        }),
      },
      user.token,
      dispatch,
    );
    if (status === "confirmed") {
      getNotificationSettings(user.token)
        .then((res) => {
          showAddressBookModal(dispatch, {
            ...homePageEvent,
            modalType: "event",
          });
        })
        .catch((err) => console.log("NOTIFICATION SETTINGS err:", err));
    }
  };

  const handleUserRsvp = () => {
    if (!user) {
      return showLoginModal(dispatch);
    }

    if (isLive) {
      return goToGeneralLobby();
    }

    const status = homePageEvent?.user_rsvp?.find(
      (rsvp) => rsvp.user._id === user?._id && rsvp.status === "confirmed",
    )
      ? "removed"
      : "confirmed";
    if (homePageEvent.isRecurrEvent && status === "confirmed") {
      setOpenConfirmationModal(true);
    } else {
      rsvpBasedOnUserPrompt();
    }
  };
  if (!homePageEvent) {
    return <React.Fragment />;
  }
  return (
    <React.Fragment>
      <div className="w-full ">
        {!isFetching ? (
          <>
            <div
              onClick={goToRoom}
              className="relative rounded-xl cursor-pointer"
            >
              <img
                src={
                  homePageEvent?.cover
                    ? homePageEvent?.cover?.urls?.regular
                    : ""
                }
                alt=""
                className="w-full h-48 object-cover rounded-t-xl"
                loading="lazy"
              />
              <div className="absolute bg-gray-700 opacity-50  top-0 bottom-0 left-0 right-0 rounded-t-xl"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full">
                <p className="text-frescoWhite font-normal text-sm text-center">
                  {_renderEventTime()}
                </p>
                <p className="text-white font-bold text-2xl text-center">
                  {homePageEvent?.title}
                </p>
              </div>
              <div
                className={`absolute top-3 ${isLive ? "right-14" : "right-3"}`}
              >
                <CopyButton
                  title={`Vibehut - ${
                    homePageEvent?.room?.name || homePageEvent?.room[0]?.name
                  }`}
                  url={`${frontEndURL}/${
                    homePageEvent.room[0]?._id || homePageEvent.room?._id
                  }/events/${homePageEvent?._id}`}
                  type="icon"
                  leftPosition="-left-9"
                  bgColor="transparent"
                  ratio="w-6 h-6"
                />
              </div>
              {isLive ? (
                <div className="absolute top-3 right-3">
                  <LiveIcon />
                </div>
              ) : undefined}
            </div>
            <div className="h-44 bg-frescoWhite dark:bg-navyGray w-full  rounded-b-xl relative">
              <div className="p-4">
                <p className="uppercase text-sm font-medium text-darkGray">
                  HIGHLIGHTED
                </p>
                <div className="flex pt-2 space-x-3 custom-scrollbar overflow-x-auto">
                  {homePageEvent?.rsvps
                    ?.filter(
                      (rsvp) =>
                        rsvp.status === "confirmed" && rsvp?.isHighLighted,
                    )
                    .slice(0, 5)
                    .map((rsvp, index) => (
                      <UserAvatar
                        key={rsvp?._id}
                        rsvp={rsvp}
                        index={index}
                        avatarSize={avatarSize}
                      />
                    ))}
                </div>
              </div>
              <div className="absolute w-full bottom-0">
                <div className="flex justify-between w-full p-4">
                  <div
                    className="flex items-center -ml-1 cursor-pointer pt-2"
                    onClick={() => setIsOpenUserList(true)}
                  >
                    <div className="-space-x-3 flex overflow-hidden ">
                      {homePageEvent?.rsvps
                        ?.filter((rsvp) => rsvp.status === "confirmed")
                        .slice(0, 3)
                        .map((rsvp, index) => (
                          <div
                            key={index}
                            className="inline-flex relative overflow-hidden rounded-full border-2 border-frescoWhite dark:border-matteGray bg-frescoWhite dark:bg-navyGray"
                          >
                            <Avatar
                              src={getUserData(rsvp.user).profile_picture}
                              username={getUserData(rsvp.user).username}
                              size="xs"
                            />
                          </div>
                        ))}
                    </div>
                    {homePageEvent?.rsvp_count &&
                      homePageEvent?.rsvp_count > 3 && (
                        <p className="pl-1 font-normal text-sm text-darkGray">
                          +{homePageEvent?.rsvp_count - 3}{" "}
                        </p>
                      )}
                  </div>
                  <div>
                    {isLive ? (
                      <Button
                        disabled={
                          homePageEvent &&
                          homePageEvent.room &&
                          homePageEvent.room[0] &&
                          !isRoomModerator(homePageEvent.room[0]) &&
                          !homePageEvent.room[0].blockedUsers?.includes(
                            user?._id,
                          ) &&
                          (homePageEvent.room[0].isNftCollectionRoom ||
                            (homePageEvent.room[0]
                              .isSubscriberRequireApproval &&
                              !homePageEvent.room[0].subscriberApprovedUsers?.includes(
                                user?._id,
                              ))) &&
                          !homePageEvent.room[0].isAccessible
                        }
                        onClick={handleUserRsvp}
                        size="vibhut-sm"
                        variant="vibhut-primary"
                      >
                        Join Now
                      </Button>
                    ) : eventId === homePageEvent?._id ? (
                      <Loader />
                    ) : homePageEvent?.user_rsvp?.find(
                        (rsvp) =>
                          rsvp.user._id === user?._id &&
                          rsvp.status === "confirmed",
                      ) ? (
                      <Button
                        onClick={handleUserRsvp}
                        variant="vibhut-primary-outline"
                        size="vibhut-sm"
                      >
                        Un-RSVP
                      </Button>
                    ) : (
                      <Button
                        onClick={handleUserRsvp}
                        size="vibhut-sm"
                        variant="vibhut-primary"
                      >
                        RSVP
                      </Button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {isOpenUserList && (
              <UserListModal
                isOpen={isOpenUserList}
                setIsOpen={setIsOpenUserList}
                event={homePageEvent}
              />
            )}
          </>
        ) : (
          <HomeEventSkeleton />
        )}
      </div>
      {openConfirmationModal && (
        <ConfirmationModal
          title="Attend Event"
          text={"This is a recurring event. Would you like to attend:"}
          openModal={openConfirmationModal}
          setOpenModal={setOpenConfirmationModal}
          primaryButtonText="Attend"
          primaryAction={(index) => {
            setOpenConfirmationModal(false);
            if (index === 1 || !index) {
              rsvpBasedOnUserPrompt(false);
            }
            if (index === 2) {
              rsvpBasedOnUserPrompt(true);
            }
          }}
          secondaryButtonText={"Cancel"}
          secondaryAction={() => {
            setOpenConfirmationModal(false);
          }}
          radioBoxData={["Only this event", "This and following events"]}
        />
      )}
    </React.Fragment>
  );
}
export default PopularEventCard;
